import type { LandingAchievementId } from '@/lib/landing-achievements'

export type AchievementDefinition = {
  id: LandingAchievementId
  number: number
  title: string
  eyebrow: string
  description: string
  lockedHint: string
  image: string
}

export const ACHIEVEMENT_DEFINITIONS: AchievementDefinition[] = [
  {
    id: 'first_purchase',
    number: 1,
    title: 'Primeiro passo',
    eyebrow: 'Conquista de bronze',
    description: 'Você fez sua primeira compra nesta campanha.',
    lockedHint: 'Faça sua primeira compra',
    image: '/conquistas%20doa%C3%A7%C3%B5es/01%20primeira%20compra.png',
  },
  {
    id: 'frequent_supporter',
    number: 2,
    title: 'Apoiador frequente',
    eyebrow: 'Conquista de prata',
    description: 'Você voltou e fortaleceu esta campanha novamente.',
    lockedHint: 'Complete 2 compras',
    image: '/conquistas%20doa%C3%A7%C3%B5es/02%20comprador%20frequente.png',
  },
  {
    id: 'special_supporter',
    number: 3,
    title: 'Apoiador especial',
    eyebrow: 'Conquista de ouro',
    description: 'Você acumulou R$ 1.000 em compras nesta campanha.',
    lockedHint: 'Acumule R$ 1.000 em compras',
    image: '/conquistas%20doa%C3%A7%C3%B5es/03%20comprador%20especial.png',
  },
  {
    id: 'profile_complete',
    number: 14,
    title: 'Perfil completo',
    eyebrow: 'Conquista especial',
    description:
      'Seu cadastro está completo. Obrigado por manter seus dados atualizados!',
    lockedHint: 'Complete 100% do seu perfil',
    image: '/conquistas%20doa%C3%A7%C3%B5es/14%20perfil%20completo.png',
  },
  {
    id: 'avatar_customized',
    number: 17,
    title: 'Avatar personalizado',
    eyebrow: 'Conquista de diamante',
    description: 'Você criou um avatar com a sua cara para sua conta na Sortee!',
    lockedHint: 'Personalize e salve seu avatar',
    image: '/conquistas%20doa%C3%A7%C3%B5es/17%20avatar%20personalizado.png',
  },
  {
    id: 'scratch_card',
    number: 21,
    title: 'Raspadinha',
    eyebrow: 'Uma surpresa para você',
    description: 'Você revelou sua raspadinha nesta campanha!',
    lockedHint: 'Raspe e descubra sua sorte',
    image: '/conquistas%20doa%C3%A7%C3%B5es/21%20Raspadinha.png',
  },
  {
    id: 'roulette',
    number: 22,
    title: 'Roleta',
    eyebrow: 'Um giro de sorte',
    description: 'Você girou a roleta desta campanha pela primeira vez!',
    lockedHint: 'Gire a roleta uma vez',
    image: '/conquistas%20doa%C3%A7%C3%B5es/22%20roleta.png',
  },
  {
    id: 'calendar',
    number: 23,
    title: 'Calendário',
    eyebrow: 'Cada dia conta',
    description: 'Sua presença virou conquista. Você completou sua sequência de dias!',
    lockedHint: 'Volte todos os dias com seu perfil completo',
    image: '/conquistas%20doa%C3%A7%C3%B5es/23%20calendario.png',
  },
]
